export enum FlightRateTypeEnum {
  LIVE_RATE = "live",
  FRESH_RATE = "fresh",
  EXPRESS_RATE = "express",
  CONTRACT_RATE = "contract",
  MARKET_RATE = "market",
  PROMO_RATE = "promo",
  ESTIMATED_RATE = "estimated",
}
